import { EventInstanceStatus } from "@/domain/eventInstance.interface";

export type StatusChipColor =
	| "default"
	| "primary"
	| "secondary"
	| "info"
	| "success"
	| "warning"
	| "error";

export interface StatusDisplay {
	label: string;
	color: StatusChipColor;
	description: string;
}

const STATUS_DISPLAY: Record<EventInstanceStatus, StatusDisplay> = {
	SCHEDULED: {
		label: "Scheduled",
		color: "default",
		description: "Created by midnight job, notification not yet sent",
	},
	PENDING: {
		label: "Pending",
		color: "warning",
		description: "Notification delivered, awaiting submission",
	},
	SUBMITTED: {
		label: "Submitted",
		color: "warning",
		description: "Submission received",
	},
	PENDING_APPROVAL: {
		label: "Pending Approval",
		color: "warning",
		description: "In clinician review queue",
	},
	APPROVED: {
		label: "Approved",
		color: "success",
		description: "Manually approved — onApproval actions running",
	},
	REJECTED: {
		label: "Rejected",
		color: "error",
		description: "Rejected — participant may resubmit",
	},
	COMPLETED: {
		label: "Completed",
		color: "success",
		description: "Successfully completed",
	},
	EXPIRED: {
		label: "Expired",
		color: "error",
		description: "Submission window closed (missed)",
	},
	DELIVERY_FAILED: {
		label: "Delivery Failed",
		color: "error",
		description: "Push notification could not be delivered",
	},
	SKIPPED: {
		label: "Skipped",
		color: "default",
		description: "Participant opted to skip",
	},
};

export const getStatusDisplay = (
	status: EventInstanceStatus | string | undefined,
): StatusDisplay => {
	if (!status) {
		return {
			label: "Unknown",
			color: "default",
			description: "Status not set",
		};
	}
	const known = STATUS_DISPLAY[status as EventInstanceStatus];
	if (known) return known;
	return { label: status, color: "default", description: "" };
};
